template = require('./incrementors.html.slim')

angular.module('wbComponents').directive 'incrementors', ->

  replace: true
  restrict: "EA"
  require: "ngModel"

  scope:
    model: "=ngModel"
    min: '@'
    max: '@'
    step: '@'
    places: '@'
    incrementors: '@'
    inputId: '@'

  templateUrl: template

  link: ($scope, element, attrs, ngModel)->
    isValueNotNumber = ->
      $scope.incrementorForm.incrementorInput.$error?.number or
        $scope.incrementorForm.incrementorInput.$valid and !angular.isNumber($scope.model)

    # Checks to make sure the value is over the min specified in the element
    isValueUnderMin = ->
      $scope.incrementorForm.incrementorInput.$error?.min or
      $scope.model <= $scope.min

    # Checks to make sure the value is under the max specified in the element
    isValueOverMax = ->
      $scope.incrementorForm.incrementorInput.$error?.max or
      $scope.model >= $scope.max

    $scope.incDisabled = -> isValueOverMax() or isValueNotNumber()
    $scope.decDisabled = -> isValueUnderMin() or isValueNotNumber()

    # Decreases the amount in the field by the specified step
    $scope.decrement = =>
      return if $scope.decDisabled();
      if $scope.incrementorForm.incrementorInput.$error?.max
        $scope.model = Number($scope.max)
      else
        $scope.model = Number($scope.model) - Number($scope.step)

    # Increases the amount in the field by the specified step
    $scope.increment = ->
      return if $scope.incDisabled();
      if $scope.incrementorForm.incrementorInput.$error?.min
        $scope.model = Number($scope.min)
      else
       $scope.model = Number($scope.model) + Number($scope.step)

    element.find('input').on 'keydown keypress', (event) ->
      if event.keyCode in [13] # Enter
        event.preventDefault()
      if event.keyCode in [38]
        event.preventDefault()
        $scope.$apply($scope.increment)
      if event.keyCode in [40]
        event.preventDefault()
        $scope.$apply($scope.decrement)
